// extracted by mini-css-extract-plugin
export default {"inputFields":"_5ZjQPD0EiFwpXczuZT8I8d","startDate":"_9nT9TMYIrWA4ZFNw212om","icon":"_2XZNvg11xb62bryBbHyOo0","priority":"_6cdHaczqQFsu87VtvVMrtj"};